'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import Link from 'next/link'
import { useForm } from 'react-hook-form'

import { TSignIn, ZSignIn } from '@/entities/auth'
import { Button, Form } from '@/shared/ui'

import { useSignIn } from '../../api/sign-in'

const defaultValues: TSignIn = {
  username: '',
  password: '',
  rememberMe: false,
}

export const SignInForm = () => {
  const form = useForm<TSignIn>({
    resolver: zodResolver(ZSignIn),
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  })

  const signIn = useSignIn(form)

  const submitForm = (data: TSignIn) => {
    signIn.execute(data)
  }

  return (
    <Form.Root form={form}>
      <Form.Field name="username">
        <Form.Label className="font-medium text-black">이메일 주소</Form.Label>
        <Form.TextField
          type="email"
          placeholder="이메일 주소를 입력해 주세요"
          fullWidth
          autoComplete="username"
        />
        <Form.Message />
      </Form.Field>
      <Form.Field name="password" className="mt-6">
        <Form.Label className="font-medium text-black">비밀번호</Form.Label>
        <Form.PasswordField
          placeholder="비밀번호를 입력해 주세요"
          fullWidth
          autoComplete="on"
        />
        <Form.Message className="whitespace-break-spaces" />
      </Form.Field>

      <div className="mt-4 flex items-center justify-between">
        <Form.Field name="rememberMe">
          <Form.Checkbox size="small">자동 로그인</Form.Checkbox>
        </Form.Field>
      </div>

      <Button
        size="large"
        className="mt-10 mb-2.5"
        type="submit"
        fullWidth
        onClick={form.handleSubmit(submitForm)}
      >
        로그인
      </Button>

      <Button asChild variant="outline" size="large" fullWidth>
        <Link href="/sign-up">회원가입</Link>
      </Button>
    </Form.Root>
  )
}
